$(document).ready(function(){
    if($('#card-images').length > 0 && $('#card-images .min-image').length > 1)
    {
        $('#card-images .min-image').click(changeMainImage);
    }
});

function changeMainImage(e) {

    // 1. Obtener la nueva URL de la imagen principal
    if(!this.dataset.fullSrc)
        return;
    
    const thumbail = $(this);
    const newSrc = thumbail.data('full-src');

    const TRANSITION_DURATION = 300; 

    const main = $('#card-images .main-image');
    
    // Si ya es la imagen actual, salimos
    if (main.attr('src') === newSrc) {
        return;
    }

    // 2. Iniciar la transición de desvanecimiento (fade-out)
    main.addClass('image-fading');

    // 3. Actualizar el estado de selección de las miniaturas
    $('#card-images .min-image').removeClass('selected');

    thumbail.addClass('selected');

    // 4. Esperar a que el desvanecimiento termine (300ms)
    setTimeout(() => {
        // Cambiar la fuente de la imagen
        main.attr('src', newSrc);
        
        // 5. Iniciar la transición de aparición (fade-in)
        // Se agrega un pequeño retraso (50ms) para asegurar que la propiedad src se haya aplicado
        setTimeout(() => {
             main.removeClass('image-fading');
        }, 50); 

    }, TRANSITION_DURATION);
}